export default __webpack_public_path__ + "static/media/MOTIVO_03.9b42c725.jpg";